import { Pipe, PipeTransform } from '@angular/core';
import { GalleryStatus } from '@picflow/types';

@Pipe({
  name: 'galleryStatusOrder',
  standalone: true,
})
export class GalleryStatusOrderPipe implements PipeTransform {
  transform(statuses: GalleryStatus[]): GalleryStatus[] {
    const order: GalleryStatus[] = ['no_status', 'review', 'progress', 'revisions', 'approved'];
    return order.filter(s => statuses.includes(s));
  }
}
